export default [
  { text: '10:00-12:00', minHour: 10, maxHour: 12 },
  { text: '12:00-14:00', minHour: 12, maxHour: 14 },
  { text: '14:00-16:00', minHour: 14, maxHour: 16 },
  { text: '16:00-18:00', minHour: 18, maxHour: 18 },
]
